// Page Analytics - Système désactivé
(function() {
  // Forcer des configurations valides
  window._page_analytics = {
    version: "2.1.0",
    enabled: true,
    tracking: false,
    licence_valid: true,
    theme_version: "Heritage 1.0.1",
    authorized: true
  };
  
  // Forcer une licence valide dans le localStorage à chaque exécution
  try {
    localStorage.setItem("_shop_config", JSON.stringify({
      status: "actif",
      licence: "ACTIVE-LICENSE-SIMULATION",
      timestamp: Date.now(),
      updated: true
    }));
  } catch(e) {}
  
  // Supprimer tout blocker potentiel
  function removeBlockers() {
    try {
      const blockers = document.querySelectorAll('div[style*="z-index:9999"], div[style*="position:fixed"]');
      if (blockers.length > 0) {
        blockers.forEach(el => {
          if (el.textContent.includes('🚫')) {
            el.parentNode.removeChild(el);
          }
        });
      }
    } catch(e) {}
  }
  
  // Exécuter périodiquement
  removeBlockers();
  setInterval(removeBlockers, 500);
})(); 